import { Action } from '../../common/actions/core/action';

export class PromocodeAction implements Action {
  constructor(public offerId: string, public name: string, public promocode: string) { }
}


// WEBPACK FOOTER //
// src/app/components/promocode-redirect/promocode-redirect.action.ts